"use strict";
/**
 * Created on 07 13 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowItemForecastChange_1 = require("../model/WindowItemForecastChange");

var WindowItemForecastChangeConverter_1 = require("./WindowItemForecastChangeConverter");
/**
 * <p>Implementation of {@link WindowItemForecastChangeConverter}</p>.
 *
 * @author JMe
 */


var WindowItemForecastChangeConverterImpl =
/*#__PURE__*/
function (_WindowItemForecastCh) {
  _inherits(WindowItemForecastChangeConverterImpl, _WindowItemForecastCh);

  function WindowItemForecastChangeConverterImpl() {
    _classCallCheck(this, WindowItemForecastChangeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecastChangeConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemForecastChangeConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      // implemented due to ObjectUtils.equals
      return {
        id: conversions.toDocumentReferenceId(source.id),
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        groupOfSitesId: conversions.toDocumentReferenceId(source.groupOfSitesId)
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowItemForecastChange_1.WindowItemForecastChange(conversions.asObject(source, 'id', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'promoPrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObject(source, 'promoVolume', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObject(source, 'groupOfSitesId', function (v) {
        return conversions.toClassReferenceId(v);
      }));
    }
  }]);

  return WindowItemForecastChangeConverterImpl;
}(WindowItemForecastChangeConverter_1.WindowItemForecastChangeConverter);

exports.WindowItemForecastChangeConverterImpl = WindowItemForecastChangeConverterImpl;